import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { CONTENT_WIDTH } from "../../../config";

interface Props extends BoxProps {
  children: ReactNode;
  fullWidth?: boolean;
  fillHeight?: boolean;
}

/**
 * `minH` rather than `h`: at a fixed height, a page taller than the viewport overflows this box and
 * escapes the scroll container's padding box, so the page ends flush against the bottom edge however
 * much padding the shell sets. Growing with its content keeps that padding at the end of the scroll.
 *
 * `fillHeight` opts a page out of that: it takes the scroll container's full height as a definite height
 * so a page that manages its own internal scrolling (e.g. the contract-search chat, whose composer must
 * stay pinned) fits the viewport instead of growing the shell scroll.
 */
export const PageContainer = ({ children, fullWidth = false, fillHeight = false, ...rest }: Props) => (
  <Box
    w="full"
    h={fillHeight ? "full" : undefined}
    minH={fillHeight ? 0 : "full"}
    mx="auto"
    maxW={fullWidth ? "full" : CONTENT_WIDTH}
    {...rest}
  >
    {children}
  </Box>
);
